function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8846 8.72266H16.6538V17.9534H25.8846V8.72266Z",
  fill: "#05062C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8846 23.4915H16.6538V32.7222H25.8846V23.4915Z",
  fill: "#05062C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8846 38.2615H16.6538V47.4922H25.8846V38.2615Z",
  fill: "#05062C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4231 8.72266H46.1923V17.9534H55.4231V8.72266Z",
  fill: "#05062C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4231 23.4915H46.1923V32.7222H55.4231V23.4915Z",
  fill: "#05062C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4231 38.2615H46.1923V47.4922H55.4231V38.2615Z",
  fill: "#05062C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6538 17.9534H31.4231V27.1841H40.6538V17.9534Z",
  fill: "#05062C"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6538 32.7224H31.4231V41.9532H40.6538V32.7224Z",
  fill: "#05062C"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6538 47.4917H31.4231V56.7225H40.6538V47.4917Z",
  fill: "#05062C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M230.787 18.2611H231.731V21.0303H232.038V18.2611H232.982V17.9534H230.787V18.2611Z",
  fill: "#05062C"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M235.833 17.9534L234.972 20.6611L234.09 17.9534H233.556V21.0303H233.864V18.3636L234.767 21.0303H235.156L236.038 18.3636V21.0303H236.346V17.9534H235.833Z",
  fill: "#05062C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M84.6332 42.2408C84.6332 43.4716 85.3307 44.0459 86.4384 44.0459C87.5461 44.0459 87.8332 43.8818 88.4691 43.5126V45.9126C87.6691 46.7126 86.705 47.3075 84.8999 47.3075C83.0948 47.3075 80.7973 45.5023 80.5307 42.7126C79.2589 45.4408 75.9358 47.4716 72.1409 47.4716C68.346 47.4716 64.6743 45.01 64.6743 41.01C64.6743 37.01 68.4691 34.7741 74.0691 33.6459L80.3666 32.3741V31.4716C80.3666 28.2716 78.4999 26.3023 75.2384 26.3023C71.9768 26.3023 70.0691 28.2716 69.3717 30.9998L65.4127 30.4664C66.3153 26.0972 69.7819 22.8972 75.2794 22.8972C80.7768 22.8972 84.6127 25.8921 84.6127 31.8203V42.2818V42.2408H84.6332ZM80.3666 35.287L75.1358 36.4152C71.4435 37.2152 69.105 37.9126 69.105 40.7434C69.105 43.5741 70.4384 44.21 73.105 44.21C77.2076 44.21 80.3666 41.1126 80.3666 36.4152V35.287Z",
  fill: "#05062C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M95.3204 54.877H90.8897V23.4923H95.3204V28.4154C96.3256 25.5231 99.3204 22.8564 103.71 22.8564C110.603 22.8564 114.377 28.2923 114.377 35.1847C114.377 42.077 110.582 47.4513 103.71 47.4513C96.8384 47.4513 96.3461 44.8257 95.3204 41.9539V54.8564V54.877ZM95.1974 35.8206C95.1974 40.9488 98.4589 43.9436 102.664 43.9436C106.869 43.9436 109.761 40.518 109.761 35.1847C109.761 29.8513 107.259 26.4257 102.664 26.4257C98.0692 26.4257 95.1974 29.4206 95.1974 34.4872V35.8206Z",
  fill: "#05062C"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M121.085 54.877H116.654V23.4923H121.085V28.4154C122.09 25.5231 125.085 22.8564 129.474 22.8564C136.367 22.8564 140.141 28.2923 140.141 35.1847C140.141 42.077 136.346 47.4513 129.474 47.4513C122.603 47.4513 122.11 44.8257 121.085 41.9539V54.8564V54.877ZM120.982 35.8206C120.982 40.9488 124.244 43.9436 128.449 43.9436C132.654 43.9436 135.546 40.518 135.546 35.1847C135.546 29.8513 133.044 26.4257 128.449 26.4257C123.854 26.4257 120.982 29.4206 120.982 34.4872V35.8206Z",
  fill: "#05062C"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M154.295 22.8564C161.126 22.8564 164.818 27.4513 165.29 33.0513L161.392 33.318C161.023 29.2154 158.562 26.4257 154.233 26.4257C149.905 26.4257 146.869 29.7898 146.869 35.1847C146.869 40.5795 149.864 43.9436 154.233 43.9436C158.603 43.9436 161.003 41.0103 161.392 36.9077L165.29 37.277C164.818 42.9385 161.126 47.4718 154.295 47.4718C147.464 47.4718 142.336 42.6103 142.336 35.2052C142.336 27.8 147.238 22.877 154.295 22.877V22.8564Z",
  fill: "#05062C"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M187.546 42.2408C187.546 43.4716 188.244 44.0459 189.351 44.0459C190.459 44.0459 190.746 43.8818 191.382 43.5126V45.9126C190.582 46.7126 189.618 47.3075 187.813 47.3075C186.008 47.3075 183.71 45.5023 183.444 42.7126C182.172 45.4408 178.849 47.4716 175.054 47.4716C171.259 47.4716 167.587 45.01 167.587 41.01C167.587 37.01 171.382 34.7741 176.982 33.6459L183.279 32.3741V31.4716C183.279 28.2716 181.413 26.3023 178.151 26.3023C174.89 26.3023 172.982 28.2716 172.285 30.9998L168.326 30.4664C169.228 26.0972 172.695 22.8972 178.192 22.8972C183.69 22.8972 187.526 25.8921 187.526 31.8203V42.2818V42.2408H187.546ZM183.279 35.287L178.049 36.4152C174.356 37.2152 172.018 37.9126 172.018 40.7434C172.018 43.5741 173.351 44.21 176.018 44.21C180.121 44.21 183.279 41.1126 183.279 36.4152V35.287Z",
  fill: "#05062C"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M195.813 38.7129C196.244 42.2821 198.746 44.2103 202.746 44.2103C206.746 44.2103 208.141 43.0821 208.141 40.7436C208.141 38.4052 206.603 37.8103 203.71 37.277L199.751 36.5795C195.382 35.8821 192.756 34.0154 192.756 30.0154C192.756 26.0154 196.326 22.8564 201.72 22.8564C207.115 22.8564 211.546 25.7488 211.977 31.1231L208.408 31.3282C207.874 27.759 205.679 26.0975 201.741 26.0975C197.803 26.0975 196.879 27.4308 196.879 29.5641C196.879 31.6975 198.049 32.3949 200.449 32.8257L204.818 33.5231C209.515 34.3231 212.285 36.0872 212.285 40.2923C212.285 44.4975 208.182 47.4513 202.726 47.4513C197.269 47.4513 192.469 44.7231 192.059 38.959L195.792 38.6923L195.813 38.7129Z",
  fill: "#05062C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M216.633 26.6918H213.105V24.2918L214.602 24.0252C217.782 23.4098 218.5 17.9534 218.5 17.9534H221.002V23.4918H227.731V26.6918H221.002V40.8457C221.002 42.9175 221.864 43.8816 223.895 43.8816C225.926 43.8816 226.397 43.3072 227.731 42.5688V45.4816C226.028 46.7534 224.859 47.4508 222.295 47.4508C219.731 47.4508 216.633 45.9123 216.633 41.3585V26.6713V26.6918Z",
  fill: "#05062C"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 65,
    viewBox: "0 0 253 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.871a8efc.svg";
export { ForwardRef as ReactComponent };